import { Controller } from "@hotwired/stimulus"

// ASS-26 — the assistant saves by itself: after a pause in the typing and when
// the step is left. Nothing here submits the form in the Turbo sense, because
// that would navigate and take the cursor with it; it posts the same fields to
// the same action and the server answers with no content (ASS-1).
//
// ASS-27 — there is no conflict detection, on purpose: the last save wins. A
// draft belongs to one spot of one site and is worked on by one person; nothing
// reaches a screen without a release (SPT-50), and the history says who wrote
// last (SPT-45).
export default class extends Controller {
  static targets = ["done"]
  static values = { url: String, delay: { type: Number, default: 1200 } }

  connect() {
    this.dirty = false
    this.leaving = this.save.bind(this)
    // Leaving the step, the page or the tab: whatever is unsaved goes first
    // (ASS-29).
    document.addEventListener("turbo:before-visit", this.leaving)
    window.addEventListener("pagehide", this.leaving)
  }

  disconnect() {
    document.removeEventListener("turbo:before-visit", this.leaving)
    window.removeEventListener("pagehide", this.leaving)
    clearTimeout(this.timer)
  }

  changed(event) {
    // A file input is not autosaved: the upload has its own road (MED-41) and
    // the form is submitted for it in the ordinary way.
    if (event.target?.type === "file") return

    this.dirty = true
    this.state("unsaved")
    clearTimeout(this.timer)
    this.timer = setTimeout(() => this.save(), this.delayValue)
  }

  async save() {
    if (!this.dirty) return

    clearTimeout(this.timer)
    this.dirty = false
    this.state("saving")

    const body = new FormData(this.element)
    body.append("autosave", "1")

    try {
      const response = await fetch(this.urlValue, {
        method: "POST",
        body: this.withMethod(body),
        headers: { "X-CSRF-Token": this.token() },
        credentials: "same-origin"
      })

      this.state(response.ok ? "saved" : "failed")
      if (!response.ok) this.dirty = true
    } catch {
      // Offline in the back of a market is the ordinary case, not an incident:
      // the state says so and the next change tries again (ASS-45).
      this.state("failed")
      this.dirty = true
    }
  }

  withMethod(body) {
    body.append("_method", "patch")
    return body
  }

  token() {
    return document.querySelector("meta[name=csrf-token]")?.content || ""
  }

  state(name) {
    const label = document.querySelector("[data-spot-assistant-target=savedState]")
    if (!label) return

    label.textContent = label.dataset[name] || ""
    label.classList.toggle("text-danger", name === "failed")
  }
}
